import { InventoryTree } from '@scaleaq/sitecontrol-lib';

/**
 * Recursively searches for an InventoryTree node by its id.
 * @param sourceId - The id of the inventory to find.
 * @param nodes - The array of InventoryTree nodes to search in.
 * @returns The InventoryTree node with the matching id, or undefined if not found.
 */
export const findNameForIdInInventoryTree = (
  sourceId: string,
  nodes: InventoryTree[]
): InventoryTree | undefined => {
  for (const node of nodes) {
    if (node.id === sourceId) return node;

    const childNodes = node.inventories ?? [];
    const found = findNameForIdInInventoryTree(sourceId, childNodes);
    if (found) return found;
  }

  return undefined;
};
